import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Button} from 'antd'
import {alertMessage} from '../../../utils'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

@inject('rulesManagementStore')
@observer
class CommentsModal extends Component {
  formRef = React.createRef()

  handleOk = () => {
    const {rulesManagementStore, ruleId, handleCancel, type, versionId} = this.props

    this.formRef.current.validateFields().then(fieldsValue => {
      if (type === 'Record') {
        rulesManagementStore.onRecord({comments: fieldsValue.comments, ruleId}).then(res => {
          if (res?.data?.code === 0) {
            handleCancel()
            alertMessage.success(res?.data?.message).then()
          }
        })
      } else {
        rulesManagementStore.onRecover({comments: fieldsValue.comments, ruleId, versionId}).then(res => {
          if (res?.data?.code === 0) {
            handleCancel()
            alertMessage.success(res?.data?.message).then()
          }
        })
      }
    })
  }

  render() {
    const {modalVisible, handleCancel, type, t} = this.props
    return (
      <Modal
        title={`${type} ${t(`rulesManagement.version`)}`}
        closable={true}
        onCancel={handleCancel}
        visible={modalVisible}
        maskClosable={false}
        destroyOnClose={true}
        centered
        footer={[
          <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
          <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
        ]}
      >
        <Form ref={this.formRef} key="addComments" initialValues={{comments: ''}} layout="vertical">
          <Row justify="start" gutter={[10, 10]}>
            <Col span={24}>
              <Form.Item name="comments" label={t(`rulesManagement.comments`)}
                         rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`rulesManagement.comments`)}`}]}>
                <TextArea rows={4} placeholder={t(`general.pleaseEnter`)}/>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    )
  }
}

export default withTranslation()(CommentsModal)
